import React, { useEffect } from "react";
import Footer from "../../assets/images/Footer.png";
import { notifySuccess } from "../../utils/embedHelper";

const TransferSuccessful = () => {
  useEffect(() => {
    notifySuccess({ status: "success", channel: "transfer" });
  }, []);
  return (
    <div className="md:w-[562px] w-[300px] mt-40">
      <div className="flex  justify-between">
        <p className="text-orangeCard text-xl font-bold">Tribe</p>
        <div>
          <p className="text-2xl text-orangeCard font-bold">
            <span className="text-xl">NGN</span> 12,839.2
          </p>
          <p className="text-sm text-orangeCard font-normal">
            (Fee NGN 100.00)
          </p>
          <p className="text-[17.75px] text-normalText font-normal">
            mbonnudebbie@gmail.com
          </p>
        </div>
      </div>
      <div className="flex justify-center">
        <p className="text-[18.75px] font-normal text-darkGrey text-center mt-10 w-[348px]">
          Verification of transfer to the account details has been confirmed
        </p>
      </div>
      <span className="flex justify-center mt-10">
        <svg
          width="70"
          height="71"
          viewBox="0 0 70 71"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.4236e-05 35.2384C4.43192e-05 33.3366 0.143576 31.399 0.466521 29.4613C2.8348 14.7851 14.748 2.83609 29.4241 0.467808C48.2986 -2.58225 66.0965 9.58209 69.9001 28.2054C70.1872 29.6766 69.2542 31.076 67.8189 31.399C66.3477 31.686 64.9483 30.7531 64.6253 29.3177C61.3959 13.5651 46.325 3.2308 30.2853 5.85026C17.8698 7.85971 7.78666 17.9428 5.77721 30.3583C3.19363 46.4698 13.5638 61.5048 29.3882 64.6984C30.8594 64.9854 31.7924 66.4208 31.5053 67.8561C31.2183 69.3273 29.7829 70.2603 28.3476 69.9732C11.5903 66.5643 4.35067e-05 51.924 4.4236e-05 35.2384Z"
            fill="#27AE60"
          />
          <path
            d="M33.112 46.8952C32.2445 46.8952 31.4204 46.5482 30.8131 45.941L23.9598 39.131C22.7019 37.8731 22.6585 35.7911 23.9598 34.5332C25.2176 33.2753 27.2997 33.2319 28.5576 34.5332L32.9385 38.8707L45.5174 24.1664C46.6886 22.7784 48.7272 22.6483 50.1152 23.8194C51.4599 24.9906 51.6334 27.0292 50.4622 28.4172L35.6278 45.7675C35.0205 46.4615 34.1964 46.8519 33.2855 46.8952C33.1988 46.8952 33.1554 46.8952 33.112 46.8952Z"
            fill="#27AE60"
          />
        </svg>
      </span>
      <div className="flex flex-col items-center mt-4">
        <p className="text-2xl font-semibold text-darkTheme">
          Transaction Successful
        </p>
        <p className="text-sm font-normal text-darkTheme">
          Your transaction was successful
        </p>
      </div>
      <div className="flex justify-center">
        <button className=" text-white text-[14.75px] w-[307px] rounded-[10px] bg-orangeCard py-[20.19px] mt-4">
          Redirect in: 00:30
        </button>
      </div>
      <div className="flex justify-center mt-6 mb-2">
        <img src={Footer} alt="footerLogo" className="w-[227px]" />
      </div>
    </div>
  );
};

export default TransferSuccessful;
